export default {
  sap: {
    metadata: {
      title: 'Inteligencia SAP - SIS Innov & Tech',
      desc: 'Soluciones SAP para impulsar tus negocios. De consultoría e implantación hasta actualización y apoyo AMS. Obtén más información.',
    },
    hero: {
      title: 'Inteligencia SAP',
      desc: '¡Conoce nuestros servicios!',
    },
    apresentation: {
      p1: 'Tener <span class="font-black">un aliado comercial que te ayude en todas las etapas del proceso</span> para tener un sistema ERP, referencia en el mercado, hace una gran diferencia en tus resultados.',
      p2: 'En nuestra Unidad de Inteligencia SAP tenemos especialistas que ofrecen un abordaje completo y personalizado, para atender las necesidades de tu empresa relacionadas al sistema SAP. Con nosotros tienes:',
      list: ['Consultoría SAP;', 'Implantación;', 'Actualización;', 'Apoyo siempre que lo necesites.'],
    },
    carouselConsulting: {
      title: 'Una consultoría a medida para ti',
      list: [
        {
          title: 'Planificación de Recursos Empresariales',
          text: 'El SAP S/4HANA Cloud es un sistema que ya tiene IA integrada, y que ayuda a tu empresa a operar, en tiempo real, desde cualquier lugar.',
          icon: '/images/sap/icons-carousel/1.svg',
        },
        {
          title: 'Gestión de Recursos Financieros (GRC)',
          text: 'Concentra todas las etapas financieras de tu empresa en solo lugar. Desde la planificación hasta la GRC.',
          icon: '/images/sap/icons-carousel/2.svg',
        },
        {
          title: 'Gestión de Capital Humano',
          text: 'Soluciones SAP para gestionar talentos, experiencia del empleado y funciones relacionadas a RH.',
          icon: '/images/sap/icons-carousel/3.svg',
        },
        {
          title: 'Gestión de Cadena Productiva',
          text: 'Implanta el SAP con nosotros y administra tu cadena de suministro, producción y logística.',
          icon: '/images/sap/icons-carousel/4.svg',
        },
        {
          title: 'Ventas y Experiencia del Cliente',
          text: 'Conecta datos de e-commerce, ventas y servicios, personalizando la atención al cliente.',
          icon: '/images/sap/icons-carousel/5.svg',
        },
        {
          title: 'Red de Negocios',
          text: 'Conecta personas, procesos y tecnologías con la implantación del sistema SAP ERP.',
          icon: '/images/sap/icons-carousel/6.svg',
        },
      ],
    },
    whatIs: {
      title: '¿Qué incluye la Inteligencia SAP?',
      tooltip:
        '<span class="font-black">Es importante recordar que hasta 2027</span>, todas las empresas que tienen SAP ECC deben migrar para el SAP S/4 HANA. Si ya utilizas la herramienta y quieres tener una transición segura, te ofrecemos toda la ayuda necesaria.',
      list: [
        {
          title:
            '<span class="font-black"> Consultoría e Implantación SAP </span><br><span style="font-weight: 100;"> (ECC y S/4 HANA)</span>',
          items: [
            '• Implantaciones y migraciones de aplicaciones SAP, actuales o futuras;',
            '• Diagnóstico completo del ambiente SAP, incluyendo customizaciones (Zs);',
            '• Mejorías en las aplicaciones ya existentes;',
            '• Equipo especializado.',
          ],
        },
        {
          title: '<span class="font-black">SAP<br>AMS</span>',
          items: [
            '• Apoyo a las aplicaciones de negocio;',
            '• Equipo dedicado al AMS para atender las llamadas de acuerdo con la prioridad, gravedad y para mitigar impactos con alternativas y análisis de causa raíz;',
            '• Gestión proactiva basada en indicadores y acuerdos de niveles de servicio.',
          ],
        },
        {
          title: '<span class="font-black">SAP<br>CONCUR</span>',
          items: [
            '• Automatización y simplificación de procesos de gastos y viajes corporativos;',
            '• Facilidad para rellenar informes de gastos viaje y ayuda para organizar el viaje desde la reserva hasta el reembolso.',
          ],
        },
        {
          title: '<span class="font-black">PRICEFX</span>',
          items: [
            '• Solución estratégica para optimizar procesos de fijación de precio;',
            '• Optimización de procesos de fijación de precio;',
            '• Datos en tiempo real e insights para acciones;',
            '• Gestión flexible y escalable de precios.',
          ],
        },
        {
          title: '<span class="font-black"> OMNIPOS </span><br><span style="font-weight: 100;">(OMNICHANNEL)</span>',
          items: [
            '• Solución para integración de los canales de venta (e-commerce, PDV y otros) con sistemas ERP y heredados (omnicanalidad);',
            '• Gestión separada de varios canales de ventas.',
          ],
        },
        {
          title: '<span class="font-black">ANFE</span>',
          items: [
            '• Gestión y automatización en la entrada de documentos fiscales electrónicos (NFe, CTe y NFSe);',
            '• Rescate de documentos directamente de SEFAZ;',
            '• Captura, auditoría y clasificación de documentos;',
            '• Procesamiento de todas las facturas de servicios (PDF y XML).',
          ],
        },
      ],
      link: 'háblanos',
    },
    band: {
      title: '¡Da el próximo paso en dirección a<br> Innovación y Transformación Digital!',
      button: 'Habla con la gente de nuestra Unidad de Inteligencia SAP',
    },
    booster: {
      title: '¡Impulsa tus negocios con la implantación del SAP!',
      desc: 'En colaboración con CoachIT, <span class="font-black">personalizamos la estrategia ideal para atender las necesidades específicas de tu empresa.</span> Utilizando toda nuestra experiencia en el área de tecnología, nuestros consultores te acompañan desde la implantación hasta las mejorías continuas para que alcances los mejores resultados.',
      link: '¡Quiero aprovechar los beneficios del SAP!',
    },
  },
}
